import { makeRequest } from "./client";

export type SavedAskTurn = {
  conversationId: string;
  turn: number;
  question: string;
  replyKind: string;
  answeredAs?: string;
  offered?: string[];
  awaiting?: string;
  topScore?: number;
  confidence?: "confident" | "unsure" | "lost";
};

/** Fire-and-forget save of one Ask Noticeboard turn. The dashboard does not read the result. */
export const askNoticeboardApi = {
  saveTurn: async (orgId: string, token: string, turn: SavedAskTurn): Promise<{ saved: boolean }> => {
    return makeRequest(`/v1/org/${orgId}/ask-noticeboard/turns`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: JSON.stringify(turn),
    });
  },
};
